import { action, computed, observable, runInAction } from 'mobx';

import { registroImpuestosAguaStore } from './registroImpuestosAguaStore';
import { registroImpuestosPredialStore } from './registroImpuestosPredialStore';
import userStore from './userStore';

import { Modal } from 'antd';

const { confirm } = Modal;

export class CapturaStore {
    @observable
    municipioOptions: Array<{ value: number; title: string }> = [];

    @observable
    registroKinds: Array<'Predial' | 'Agua'> = [];

    @observable
    selectedMunicipioId?: number;

    @observable
    selectedRegistroKind?: string;

    @computed
    get registroImpuestosStore() {
        return this.selectedRegistroKind === 'Predial'
            ? registroImpuestosPredialStore
            : registroImpuestosAguaStore;
    }

    @computed
    get isLoading() {
        return userStore.isFetching || this.registroImpuestosStore.isLoading;
    }

    @action
    initialize = async () => {
        this.municipioOptions = userStore.municipio.map(municipio => ({
            value: municipio.id,
            title: municipio.nombre
        }));

        this.selectedMunicipioId = this.municipioOptions[0].value;
        userStore.setPermisoAgua(this.selectedMunicipioId);
        this.registroKinds =
            userStore.rol === 'ROL-ROO'
                ? ['Agua']
                : userStore.capturaAgua
                ? ['Predial', 'Agua']
                : ['Predial'];

        this.selectedRegistroKind = this.registroKinds[0];

        registroImpuestosPredialStore.setMode('captura');
        registroImpuestosAguaStore.setMode('captura');

        registroImpuestosPredialStore.setMunicipioId(this.selectedMunicipioId);

        registroImpuestosAguaStore.setMunicipioId(this.selectedMunicipioId);

        await this.registroImpuestosStore.getForm();
    };

    @action
    setMunicipioId = async (municipioId: number) => {
        if (this.registroImpuestosStore.isDirty) {
            confirm({
                title: `¿Quieres cambiar de municipio?`,
                content: 'Usted tiene cambios no guardados.',
                okText: 'Sí',
                cancelText: 'No',
                onOk: () =>
                    runInAction(async () => {
                        this.selectedMunicipioId = municipioId;
                        this.registroImpuestosStore.setMunicipioId(municipioId);
                        await this.registroImpuestosStore.getForm();
                    })
            });
        } else {
            this.selectedMunicipioId = municipioId;
            this.registroImpuestosStore.setMunicipioId(municipioId);
            await this.registroImpuestosStore.getForm();
        }
    };

    @action
    setRegistroKind = async (registroKind: string) => {
        this.selectedRegistroKind = registroKind;
        await this.registroImpuestosStore.getForm();
    };
}

export const capturaStore = new CapturaStore();
